
import type { ClassificationNode } from "@/types/classifications";
import type { Json } from "@/integrations/supabase/types";

export const convertToClassificationNode = (json: Json): ClassificationNode => {
  if (!json || typeof json !== 'object') {
    throw new Error('Invalid classification data');
  }
  
  const node = json as any;
  return {
    id: node.id as string,
    name: node.name as string,
    type: node.type as ClassificationNode['type'],
    children: Array.isArray(node.children) 
      ? node.children.map((child: Json) => convertToClassificationNode(child))
      : []
  };
};

export const updateNodeInTree = (
  tree: ClassificationNode,
  updatedNode: ClassificationNode
): ClassificationNode => {
  if (tree.id === updatedNode.id) {
    return { ...tree, ...updatedNode };
  }

  return {
    ...tree,
    children: tree.children.map(child => updateNodeInTree(child, updatedNode))
  };
};
